import React from "react";
import ContentWrapper from "../master/ContentWrapper";
import PageTitle from "../master/PageTittle";
import SideBar from "../master/SideBar";
import {about} from "../const";
import playground from "../../assets/about/principals_strategic_intent.jpg"

const FromThePrincipalContent = () => (
  <div className="container">
    <ContentWrapper sidebar={true} narrow={true}>
      <div className={"content"}>
        <PageTitle title="Executive Principal’s message - Sr Katy Sawma MSHF" />

        <p></p>
        <p className="elementToProof">
          <strong>Message from the Principal</strong>
        </p>
        <p className="elementToProof">
          <strong>Dear St Maroun&rsquo;s College Community,</strong>
        </p>
        <p className="elementToProof">
          May God&rsquo;s blessings be upon each and every one of you as we
          begin this new chapter in the life of our College.
        </p>
        <p>
          As the new Principal of St Maroun&rsquo;s College, I feel deeply
          honoured and humbled to serve a community rich in faith, culture, and
          a shared commitment to the formation of young people. Guided by the
          Maronite Sisters of the Holy Family, we continue our mission of
          accompanying every student to realise their potential spiritually,
          intellectually, physically, and socially.
        </p>
        <p className="elementToProof">
          As we move into the 2026&ndash;2028 strategic period, we pause with
          gratitude for all that has been achieved. I sincerely acknowledge the
          visionary leadership of Sr Margaret Ghosn, whose faith-filled
          stewardship laid strong foundations for the growth and renewal we now
          enjoy.
        </p>
        <p className="elementToProof">
          One of our most significant milestones has been the completion and
          opening of Building D in 2026, now proudly known as the{" "}
          <strong>Rosalie Learning Centre</strong>, named in honour of Mother
          Rosalie Nasr, one of our first Foundresses. This building stands as a
          powerful symbol of faith meeting innovation, offering light-filled,
          future-focused learning spaces designed to inspire curiosity,
          creativity, and excellence. It reflects our commitment to preparing
          students for an ever-changing world while remaining firmly grounded in
          our Maronite identity.
        </p>
        <p className="elementToProof">
          In response to continued enrolment growth, we are also progressing
          with stage two of our development project. This includes protecting
          the heritage wall, enhancing the College Hall, and improving parking
          at the front of the College. These developments will ensure our
          facilities continue to meet the needs of our growing community and
          serve as places of gathering, celebration, prayer, performance, and
          shared joy.
        </p>
        <p className="elementToProof">
          I am also delighted to share the outstanding academic results achieved
          by our students in 2025, with an HSC Mastery result of{" "}
          <strong>99.4</strong>. This remarkable achievement reflects the
          dedication, professionalism, and commitment of our staff. At the same
          time, we remain focused on closely analysing our data and continually
          striving for improvement and excellence.
        </p>
        <hr />
        <p className="elementToProof">
          <strong>Our Strategic Direction: 2026&ndash;2028</strong>
        </p>
        <p className="elementToProof">
          The world our students are growing into is complex and rapidly
          evolving. Advances in technology, artificial intelligence, and social
          change call us to educate young people who are not only academically
          capable, but also resilient, ethical, adaptable, and deeply grounded
          in faith.
        </p>
        <p className="elementToProof">
          Our strategic commitments guide this important work. We remain focused
          on deepening our <strong>Maronite sisters of the holy family</strong> charism,
          mastering our pedagogy, enhancing wellbeing, expanding our capacity,
          and partnering closely with families and the wider community.
        </p>
        <p className="elementToProof">
          As an Executive Team, we are proud to reaffirm who we are through our
          clearly articulated mission, vision, and values, which guide our
          purpose and direction.
        </p>
        <hr />
        <p className="elementToProof">
          <strong>Who We Are</strong>
        </p>
        <p className="elementToProof">
          St Maroun&rsquo;s College is a Maronite Catholic K&ndash;12
          co-educational College, rich in cultural diversity and united by
          faith. We are a community where young people are invited to{" "}
          <strong>belong, believe, and become</strong>.
        </p>
        <p className="elementToProof">
          Through our values of{" "}
          <strong>Integrity, Service, and Achievement</strong>, we prepare
          students to journey forward with confidence, compassion, and courage.
        </p>
        <hr />
        <p className="elementToProof">
          <strong>Mission</strong>
        </p>
        <p className="elementToProof">
          Inspired by the Maronite Sisters of the Holy Family, we accompany our
          students in the realisation of their potential.
        </p>
        <hr />
        <p className="elementToProof">
          <strong>Vision</strong>
        </p>
        <p className="elementToProof">
          To be the leading faith-based and multicultural College where every
          community member thrives, even in the face of the unimaginable and
          unpredictable. We stand apart through real-world learning, rich
          cultural experiences, and the pursuit of bold dreams.
        </p>
        <hr />
        <p className="elementToProof">
          As we journey through this strategic period together, I sincerely
          acknowledge the dedication and commitment of our Executive members,
          Board members, Sisters, staff, students, and families. When we remain
          united in purpose and grounded in faith, we create a community where
          everyone can truly thrive.
        </p>
        <p className="elementToProof">
          I believe leadership is first and foremost an act of service, to
          listen attentively, to see the needs of others, to walk alongside
          them, and to seek God&rsquo;s guidance and providence in every
          decision. Together with the Executive Team and Board, I am ready to
          walk this path in trust, confident that Jesus continues to lead us in
          this ministry of leadership, so that together we may build a College
          filled with hope, excellence, and love.
        </p>
        <p className="elementToProof">
          Ultimately, our success rests not only in our achievements, but in our
          recognition of God&rsquo;s grace at work among us.
        </p>
        <p className="elementToProof">
          I warmly invite you to explore our College and become part of our
          story.
        </p>
        <p className="elementToProof">&nbsp;</p>
        <p className="elementToProof">Regards,</p>
        <p className="elementToProof">Sr Katy Sawma</p>
        <p className="elementToProof">Principal&nbsp;</p>
        <p id="Signature" className="elementToProof">
          &nbsp;
        </p>
        <p>&nbsp;</p>
      </div>
      <SideBar items={about} title="About Us" />
    </ContentWrapper>
  </div>
);

export default FromThePrincipalContent;
